import {
  DashboardOutlined,
  UserAddOutlined,
  CarOutlined,
  FileImageOutlined,
  HomeOutlined,
  UserOutlined,
  TeamOutlined,
  ShopOutlined,
  SettingOutlined,
  FileTextOutlined,
  DollarOutlined,
  TagsOutlined,
  MessageOutlined,
  SafetyOutlined,
  TruckOutlined,
  FundProjectionScreenOutlined,
  DatabaseOutlined,
  ScheduleOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  MergeOutlined,
  DiffOutlined,
  BarChartOutlined,
  AppstoreAddOutlined,
  ForwardOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { RoleActionEnum } from "constants/enums";
import { checkRolesByRole } from "utils/role";

// Helper function to filter menu items based on user role
const filterMenuByRole = (menuItems, userRole) => {
  if (!userRole || !userRole.actions) {
    return [];
  }

  return menuItems.filter((item) => {
    if (!item.requiredPermission) {
      return true; // No permission required, show to everyone
    }

    const permissions = checkRolesByRole(userRole, [item.requiredPermission]);
    return permissions[0];
  });
};

const dashBoardNavTree = [
  {
    key: "home",
    path: `${APP_PREFIX_PATH}/home`,
    title: "home",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const users = [
  {
    key: "users",
    path: `${APP_PREFIX_PATH}/users`,
    title: "users",
    icon: UserAddOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.UserList,
  },
];

const roles = [
  {
    key: "roles",
    path: `${APP_PREFIX_PATH}/roles`,
    title: "roles",
    icon: SafetyOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.RoleList,
  },
];

const vehicle = [
  {
    key: "vehicle",
    title: "vehicle",
    icon: TruckOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "vehicle-all",
        path: `${APP_PREFIX_PATH}/vehicle`,
        title: "Tüm Araçlar",
        icon: CarOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.VehicleList,
      },
      {
        key: "vehicle-saled",
        path: `${APP_PREFIX_PATH}/vehicle?type=saled`,
        title: "Satılmış Araçlar",
        icon: FundProjectionScreenOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.VehicleList,
      },
      {
        key: "vehicle-stock",
        path: `${APP_PREFIX_PATH}/vehicle?type=stock`,
        title: "Stoktaki Araçlar",
        icon: DatabaseOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.VehicleList,
      },
      {
        key: "expertises",
        path: `${APP_PREFIX_PATH}/expertises`,
        title: "expertises",
        icon: ScheduleOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.ExpertList,
      },
      {
        key: "services",
        path: `${APP_PREFIX_PATH}/services`,
        title: "services",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.ServiceList,
      },
    ],
    requiredPermission: RoleActionEnum.VehicleList,
  },
];

const customers = [
  {
    key: "customers",
    path: `${APP_PREFIX_PATH}/customers`,
    title: "customers",
    icon: UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CustomerList,
  },
];

const partners = [
  {
    key: "partners",
    path: `${APP_PREFIX_PATH}/partners`,
    title: "partners",
    icon: UserSwitchOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CustomerList,
  },
];

const stores = [
  {
    key: "stores",
    path: `${APP_PREFIX_PATH}/stores`,
    title: "stores",
    icon: MergeOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CustomerList,
  },
];


const projects = [
  {
    key: "projects",
    path: `${APP_PREFIX_PATH}/projects`,
    title: "projects",
    icon: DiffOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];
const immovables = [
  {
    key: "immovables",
    path: `${APP_PREFIX_PATH}/immovables`,
    title: "immovables",
    icon: HomeOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];

const slider = [
  {
    key: "slider",
    path: `${APP_PREFIX_PATH}/slider`,
    title: "slider",
    icon: FileImageOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];

const blog = [
  {
    key: "blog",
    path: `${APP_PREFIX_PATH}/blog`,
    title: "blog",
    icon: FileTextOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];

const reports = [
  {
    key: "reports",
    path: `${APP_PREFIX_PATH}/reports`,
    title: "reports",
    icon: BarChartOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];

const financial = [
  {
    key: "financialMenu",
    path: `${APP_PREFIX_PATH}/accounts`,
    title: "financialMenu",
    icon: FundProjectionScreenOutlined,
    breadcrumb: false,
    isGroupTitle: false,
    requiredPermission: RoleActionEnum.FinancialList,
    submenu: [
      {
        key: "financialMenu",
        path: `${APP_PREFIX_PATH}/accounts`,
        title: "financialMenu",
        icon: FundProjectionScreenOutlined,
        breadcrumb: false,
        requiredPermission: RoleActionEnum.FinancialList,
        submenu: [
          {
            key: "financial-transactions",
            path: `${APP_PREFIX_PATH}/financial-transaction`,
            title: "financial-transactions",
            icon: BarChartOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.FinancialList,
          },
          {
            key: "accounts",
            path: `${APP_PREFIX_PATH}/accounts`,
            title: "accounts",
            icon: DatabaseOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.FinancialList,
          },
          {
            key: "account-transactions",
            path: `${APP_PREFIX_PATH}/account-transaction`,
            title: "account-transactions",
            icon: DatabaseOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.FinancialList,
          },
          {
            key: "debt-and-credit",
            path: `${APP_PREFIX_PATH}/debt-and-credit`,
            title: "debt-and-credit",
            icon: DatabaseOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.FinancialList,
          },
        ],
      },
    ],
  },
];

const inbox = [
  {
    key: "messages",
    path: `${APP_PREFIX_PATH}/inbox`,
    title: "messages",
    icon: MessageOutlined,
    breadcrumb: false,
    submenu: [],
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
  },
];

const vehicleCategoriesBrands = [
  {
    key: "categoriesMenu",
    path: `${APP_PREFIX_PATH}/categories`,
    title: "categoriesMenu",
    icon: AppstoreAddOutlined,
    breadcrumb: false,
    isGroupTitle: false,
    requiredPermission: RoleActionEnum.CategoryBrandModelList,
    submenu: [
      {
        key: "categories-data",
        path: `${APP_PREFIX_PATH}/vehicle-data`,
        title: "categories",
        icon: AppstoreAddOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
      },
      // {
      //   key: "categories",
      //   path: `${APP_PREFIX_PATH}/categories`,
      //   title: "categories",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "brand",
      //   path: `${APP_PREFIX_PATH}/brand`,
      //   title: "brand",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "model",
      //   path: `${APP_PREFIX_PATH}/model`,
      //   title: "model",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "sub-model",
      //   path: `${APP_PREFIX_PATH}/sub-model`,
      //   title: "sub-model",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "sub-model-two",
      //   path: `${APP_PREFIX_PATH}/sub-model-two`,
      //   title: "sub-model-two",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "sub-model-three",
      //   path: `${APP_PREFIX_PATH}/sub-model-three`,
      //   title: "sub-model-three",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      // {
      //   key: "sub-model-four",
      //   path: `${APP_PREFIX_PATH}/sub-model-four`,
      //   title: "sub-model-four",
      //   icon: ForwardOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   requiredPermission: RoleActionEnum.CategoryBrandModelList,
      // },
      {
        key: "year",
        path: `${APP_PREFIX_PATH}/year`,
        title: "year",
        icon: ForwardOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
      },

      {
        key: "fuel",
        path: `${APP_PREFIX_PATH}/fuel`,
        title: "fuel",
        icon: ForwardOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
      },
      {
        key: "color",
        path: `${APP_PREFIX_PATH}/color`,
        title: "color",
        icon: ForwardOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
      },
      {
        key: "case-types",
        path: `${APP_PREFIX_PATH}/case-types`,
        title: "case-types",
        icon: ForwardOutlined,
        breadcrumb: false,
        submenu: [],
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
      }
    ],
  },
];

const other = [
  {
    key: "other",
    path: `${APP_PREFIX_PATH}/equipment`,
    title: "other",
    icon: AppstoreAddOutlined,
    breadcrumb: false,
    isGroupTitle: false,
    requiredPermission: "equipment_view",
    submenu: [
      {
        key: "other",
        path: `${APP_PREFIX_PATH}/equipment`,
        title: "other",
        icon: AppstoreAddOutlined,
        breadcrumb: true,
        requiredPermission: RoleActionEnum.CategoryBrandModelList,
        submenu: [
          {
            key: "equipment",
            path: `${APP_PREFIX_PATH}/equipment`,
            title: "equipment",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
          {
            key: "optional-equipment",
            path: `${APP_PREFIX_PATH}/optional-equipment`,
            title: "optional-equipment",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
          {
            key: "techinal-properties",
            path: `${APP_PREFIX_PATH}/techinal-properties`,
            title: "techinal-properties",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
          {
            key: "vehicle-parts",
            path: `${APP_PREFIX_PATH}/vehicle-parts`,
            title: "vehicle-parts",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: "parts_manage",
          },
          {
            key: "gear",
            path: `${APP_PREFIX_PATH}/gear`,
            title: "gear",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
          {
            key: "engine-power",
            path: `${APP_PREFIX_PATH}/engine-power`,
            title: "engine-power",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
          {
            key: "engine-displacement",
            path: `${APP_PREFIX_PATH}/engine-displacement`,
            title: "engine-displacement",
            icon: ForwardOutlined,
            breadcrumb: false,
            submenu: [],
            requiredPermission: RoleActionEnum.CategoryBrandModelList,
          },
        ],
      },
    ],
  },
];

let navigationConfig = [...dashBoardNavTree];
const userInfo = JSON.parse(localStorage.getItem("userinfo"));

// Filter menus based on user role
if (userInfo && userInfo.role) {
  const allMenus = [
    ...vehicle,
    ...customers,
    ...partners,
    ...stores,
    ...inbox,
    ...projects,
    ...slider,
    ...blog,
    ...immovables,
    ...users,
    ...roles,
    ...financial,
    ...vehicleCategoriesBrands,
    ...other,
    ...reports,
  ];

  const filteredMenus = filterMenuByRole(allMenus, userInfo.role);
  navigationConfig.push(...filteredMenus);
}

export default navigationConfig;
